interface ErrorBannerProps {
  message?: string;
}

export function ErrorBanner({ message = "Failed to load data." }: ErrorBannerProps) {
  return (
    <div
      style={{
        background: "#fee2e2",
        color: "#991b1b",
        border: "1px solid #fca5a5",
        borderRadius: 6,
        padding: "10px 14px",
        fontSize: 13,
        fontWeight: 500,
      }}
    >
      ⚠ {message}
    </div>
  );
}
